import React from 'react';
import Grid from '@mui/material/Grid';
import InformationField from '../form/components/InformationField';

interface InfoHeaderProps {
  record: Record<any, any>;
  infoLabels: object;
}

const InfoHeader: React.FC<InfoHeaderProps> = (props) => {
  const { record, infoLabels } = props;

  return (
    <Grid container spacing={2} style={{ padding: '1% 2%' }}>
      {Object.entries(infoLabels).map(([field, label]) => (
        <Grid item xs={12} md={4} key={field}>
          <InformationField label={label} value={record?.[field]} />
        </Grid>
      ))}
    </Grid>
  );
};

export default InfoHeader;
